<template>
  <div class="sms-page-container">
    <EcsWindowManager :interactions="interactions" :minimized-windows-right-offset="96" />
    <EcsCreateSms :hidden="hideDialpadFab" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsWindowManager from '@/components/ecs-window-manager/EcsWindowManager';
import EcsCreateSms from '@/components/ecs-create-sms/EcsCreateSms';

export default {
  name: 'EcsSmsPage',

  components: { EcsWindowManager, EcsCreateSms },

  computed: {
    ...mapGetters('AGENT', ['agentState']),
    ...mapGetters('INTERACTIONS', ['getActiveSmsInteractions', 'getHistoricalSmsInteractions']),
    interactions() {
      return this.getActiveSmsInteractions.concat(this.getHistoricalSmsInteractions);
    },
    hideDialpadFab() {
      return this.agentState.isOffline;
    }
  }
};
</script>

<style scoped>
.sms-page-container {
  height: 100%;
  width: 100%;
}
</style>
